const showDatePicker = () => {
 const SELECTOR_INPUT = `[type="date"], [type="month"], [type="week"], [type="time"], [type="datetime-local"]`;

 const handlePointerDown = (event) => {
 const { target } = event;

 if (
 event.button !== 0 ||
 !target.matches(SELECTOR_INPUT) ||
 target.disabled ||
 target.readOnly ||
 !('showPicker' in HTMLInputElement.prototype)
 )
 return;

 try {
 target.showPicker();
 } catch {}
 };

 const initialize = () => {
 if (showDatePicker._initialized) return;

 document.body.addEventListener(`pointerdown`, handlePointerDown);

 showDatePicker._initialized = true;
 };

 showDatePicker.cleanup = () => {
 if (!showDatePicker._initialized) return;

 document.body.removeEventListener(`pointerdown`, handlePointerDown);

 showDatePicker._initialized = false;
 };

 initialize();
};

export default showDatePicker;
